import React from "react";
import { BUSINESS } from "../../config/business";

const CREST = "https://www.jc3wealthlegacy.com/jc3-crest-on-dark.svg";

export const AuthShell = ({ children, testid }) => (
  <div data-testid={testid} className="min-h-screen pr-candle flex flex-col items-center px-5 pt-16 pb-10 overflow-x-hidden">
    <div className="w-full max-w-[520px] flex flex-col items-center pr-rise">
      <img data-testid="auth-crest" src={CREST} alt="JC3 crest" className="w-16 h-auto" />
      <h1 className="font-display text-[#F2EBDD] text-center text-4xl sm:text-5xl lg:text-6xl leading-[1.08] mt-8 max-w-[360px]">
        Executive Command Center
      </h1>
      <p className="mt-4 text-[#BDB6A6] text-sm text-center">{BUSINESS.shortName} · Private access</p>
      <div className="w-full bg-[#DCCFB9] mt-10 px-6 sm:px-8 py-8 text-[#2A1C15]">{children}</div>
    </div>
    <footer data-testid="auth-footer" className="mt-auto pt-12 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-xs text-[#BDB6A6]">
      <a href="https://www.jc3wealthlegacy.com/privacy" data-testid="footer-privacy" className="underline decoration-[#C8A46A] underline-offset-4 hover:text-[#F2EBDD]">Privacy</a>
      <a href="https://www.jc3wealthlegacy.com/terms" data-testid="footer-terms" className="underline decoration-[#C8A46A] underline-offset-4 hover:text-[#F2EBDD]">Terms</a>
      <span>© 2026 {BUSINESS.legalName} · Confidential</span>
    </footer>
  </div>
);

export const FieldLabel = ({ children, htmlFor }) => (
  <label htmlFor={htmlFor} className="block mb-2 text-sm font-medium text-[#2A1C15]">{children}</label>
);

export const FormError = ({ children, testid }) => (
  <div data-testid={testid} className="text-[#5C1A24] text-sm border border-[#5C1A24] px-3 py-2">{children}</div>
);

export const PrivateNotice = () => (
  <p data-testid="private-notice" className="mt-5 text-xs text-[#5E4D40] text-center">
    This is a private system. All access is logged and monitored.
  </p>
);
